import { useQuery } from '@tanstack/react-query';
import useGlynt from '../hooks/useGlynt';
import { useContext } from 'react';
import { AppContext } from '../../App';
import type { MatDiscoveryResponse } from '../../types/mat-types';
import { findDiscoveryItemForKey } from './MATRowDetailDrawer.utils';

interface UseMatDiscoveryByKeyArgs {
  matKey?: string | null;
  enabled?: boolean;
}

const useMatDiscoveryByKey = ({ matKey, enabled = true }: UseMatDiscoveryByKeyArgs) => {
  const glynt = useGlynt();
  const { dataPoolId } = useContext(AppContext);

  return useQuery({
    queryKey: ['mat-discovery-by-key', dataPoolId, matKey],

    queryFn: async (): Promise<MatDiscoveryResponse> => {
      const g = await glynt;
      const match = matKey
        ? await findDiscoveryItemForKey(
            (params) => g.mat.matDiscovery(params) as Promise<MatDiscoveryResponse>,
            matKey
          )
        : undefined;
      const results = match ? [match] : [];
      return { count: results.length, next: null, previous: null, results };
    },

    enabled: enabled && !!matKey,
    staleTime: 30_000
  });
};

export default useMatDiscoveryByKey;
